module.exports = __webpack_public_path__ + "static/media/alert-fill.0a51818c.svg";